module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTypesStates,
      "code": _vm.ExTypesStatesCode,
      "title": "Types and states",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSizes,
      "code": _vm.ExSizesCode,
      "title": "Sizes",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExIcons,
      "code": _vm.ExIconsCode,
      "title": "Icons",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTags,
      "code": _vm.ExTagsCode,
      "title": "Tags",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExRouter,
      "code": _vm.ExRouterCode,
      "title": "Router",
      "vertical": ""
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.6")])])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55e01e6d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/button/Button.vue
// module id = 1325
// module chunks = 21